// extracted by mini-css-extract-plugin
module.exports = {"shopifyPaymentsWrapper":"ShopifyPayments_shopifyPaymentsWrapper__3dBbd"};